import * as React from 'react';
import { observer } from 'mobx-react';
import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { BooleanView } from '../../../core/ui/boolean.view';

interface TransportCompanyOfficeListViewProps extends ComponentViewProps<DataSet<TransportCompanyOfficeItem>> {
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	onItemDoubleClicked?: (item: TransportCompanyOfficeItem) => any;
}

@observer
export class TransportCompanyOfficeListView extends React.Component<TransportCompanyOfficeListViewProps, {}> {
	constructor(props: Readonly<TransportCompanyOfficeListViewProps>) {
		super(props);
	}

	deleteOffice = (items: any[]) => {
		let office: TransportCompanyOfficeItem[] = [];
		for (const item of items) {
			office = office.concat(this.props.model.items.filter(e => e == item));
		}

		return office;
	}

	render() {
		const hideToolbar = (ToolbarVisibility.hideSearch);
		const columns = [
			{
				key: 'title',
				title: 'Title',
				dataIndex: 'title',
			},
			{
				key: 'code',
				title: 'Code',
				dataIndex: 'code'
			},
			{
				key: 'canPickup',
				title: 'Can Pickup',
				dataIndex: 'canPickup',
				render: (text: boolean) => <BooleanView size="small" value={text} mode="display" />
			},
			{
				key: 'canDropoff',
				title: 'Can Dropoff',
				dataIndex: 'canDropoff',
				render: (text: boolean) => <BooleanView size="small" value={text} mode="display" />
			}
		];

		return (
			<DataTableView
				rowKey="code"
				setBusy={this.props.setBusy}
				hideToolbar={ToolbarVisibility.hideSearch}
				columns={columns}
				model={this.props.model}
				mode={this.props.mode}
				createNewItem={() => this.props.onItemDoubleClicked(null)}
				beforeDeleteItem={this.deleteOffice}
				itemDoubleClick={(item) => {
					if (this.props.onItemDoubleClicked) {
						this.props.onItemDoubleClicked(item);
					}
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-list.view.tsx